/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { DynFormsDaoService } from '../dyn-forms-dao.service';
import { DynForm } from 'src/app/_model/dyn-form';
import {
  DbPersistenceService,
  Query,
} from 'src/app/_services/persistence/db-persistence/db-persistence.service';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { AppConfig } from 'src/app/app.config';
import { parseStringPromise } from 'xml2js';
import { DynFormDbTableDefinition } from './dyn-form-db-table-definition';

@Injectable()
export class DynFormsDbDaoService implements DynFormsDaoService {
  
  constructor(
    private logger: LoggingService,
    private dbPersistenceService: DbPersistenceService,
    private dynFormTableDefinition: DynFormDbTableDefinition,
  ) { }

  public async saveDynForms(dynForms: DynForm[]): Promise<void> {
    try {
      let db = await this.dbPersistenceService.getImsDb();
      var dynFormQueries: Query[] = [];
      for (const dynForm of dynForms) {
        let dynFormQuery: Query = {
          statement:
            'INSERT OR REPLACE INTO ' +
            this.dynFormTableDefinition.tableName +
            '(id, label, databag, name, showatfinishdialog, finalizeday, expiration,' +
            ' extid, formdata, formtranslations)' +
            ' VALUES (?,?,?,?,?,?,?,?,?,?)',
          parameters: [
            Number(dynForm.id.imsId),
            dynForm.label,
            dynForm.databag ? JSON.stringify(dynForm.databag) : undefined,
            dynForm.name,
            dynForm.showatfinishdialog,
            dynForm.finalizeday,
            dynForm.expiration,
            dynForm.extid,
            dynForm.formdata,
            dynForm.formTranslations ? JSON.stringify(dynForm.formTranslations) : undefined,  
          ],
        };
        dynFormQueries.push(dynFormQuery);
      }
      await this.dbPersistenceService.executeBatch(db, dynFormQueries);
    } catch (error) {
      this.logger.log('Error saving dynforms to db', error, '-', error?.message);
    }
  }
  public async getDynForms(): Promise<DynForm[]> {
    try {
      let db = await this.dbPersistenceService.getImsDb();
      let dynForms: DynForm[] = [];

      let data = await this.dbPersistenceService.executeQuery(db, {
        statement: 'SELECT * FROM ' + this.dynFormTableDefinition.tableName + ';',
        parameters: null,
      });
      for (let i = 0; i < data.values.length; i++) {
        let row = data.values[i];
        dynForms.push(
          await DynForm.fromDto({
            id: row['id'],
            secondaryid: undefined,
            label: row['label'],
            name: row['name'],
            showatfinishdialog: row['showatfinishdialog'] === 1,
            finalizeday: row['finalizeday'] === 1,
            expiration: row['expiration'],
            extid: row['extid'],
            formdata: row['formdata'],
            formtranslations: row['formtranslations'],
          }, row['databag'] ? JSON.parse(row['databag']) : undefined)
        );
      }

      return dynForms;
    } catch (error) {
      this.logger.log('Error reading dynforms from db', error);
    }
    return [];
  }

  public async reset() {}

  public async clear() {
    let db = await this.dbPersistenceService.getImsDb();
    this.logger.log(this.constructor.name, "truncate table", this.dynFormTableDefinition.tableName)
    await this.dbPersistenceService.truncateTable(db, this.dynFormTableDefinition.tableName);
  }
}
